import { Helmet } from "react-helmet";
import WebsiteLayout from "../components/Layouts/WebsiteLayout";
import PageBody from "../components/PropTradingSolutions/PageBody";
import { useEffect } from "react";

const PropTradingSolutions = () => {
    useEffect(() => {
        document.title = "Prop Trading Solutions | Prime Bridge";
      }, []);
      return (
        <WebsiteLayout>
          <Helmet>
            <meta
              name="description"
              content="Prime Bridge helps trading educators, communities, and academies unlock new revenue streams."
            />
          </Helmet>
          <PageBody />
        </WebsiteLayout>
      );
}

export default PropTradingSolutions;